/**
 * State of processing of work item.
 */
export enum PersistentWorkItemState {
    /**
     * Not started.
     */
    NotStarted = 0,

    /**
     * Require to pre-validation due to restore.
     */
    PreValidateByRestore = 10,

    /**
     * Pre-validating due to restore.
     */
    PreValidatingByRestore = 20,

    /**
     * Succeeded to pre-validate due to restore.
     */
    PreValidateByRestoreSuccess = 30,

    /**
     * Error to pre-validate.
     */
    PreValidateByRestoreError = 40,

    /**
     * Pre-validating.
     */
    PreValidating = 50,

    /**
     * Succeeded to pre-validate.
     */
    PreValidateSuccess = 60,

    /**
     * Error to pre-validate.
     */
    PreValidateError = 70,

    /**
     * Applying.
     */
    Applying = 80,

    /**
     * Error to apply.
     */
    ApplyError = 90,

    /**
     * Succeeded to apply.
     */
    ApplySuccess = 100,

    /**
     * Post-validating.
     */
    PostValidating = 110,

    /**
     * Error to post-validate.
     */
    PostValidateError = 120,

    /**
     * Succeeded to post-validate.
     */
    PostValidateSuccess = 130,

    /**
     * Completed.
     */
    Completed = 140
}
